export const TermsOfPayment = [
    {name:'100% against Proforma Invoice.'}, 
    {name:'100% against Delivery.'},
    {name:'100% within 7 days from the date of Invoice.'},
    {name:'100% within 15 days from the date of Invoice.'},
    {name:'100% within 30 days from the date of Invoice.'},
    {name:'100% within 45 days from the date of Invoice.'},
    {name:'100% within 60 days from the date of Invoice.'},
    {name:'30% Advance and 70% against delivery.'}
]